import { render, staticRenderFns } from "./AppLayoutSelector.vue?vue&type=template&id=048a7f07&scoped=true"
import script from "./AppLayoutSelector.vue?vue&type=script&lang=js"
export * from "./AppLayoutSelector.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutSelector.vue?vue&type=style&index=0&id=048a7f07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a7f07",
  null
  
)

export default component.exports